import { Col, Row } from "react-bootstrap";
import LicenceProfileHeader from "../LicenceProfileHeader";
import LicenceProfileSubTabs from "../LicenceProfileSubTabs";
import BreadCrumbs from "./BreadCrumbs";
import { useParams } from "react-router-dom";
import RelatedComplianceRecords from "./RelatedComplianceRecords";
import Page404 from "../../../pages/auth/Page404";
import useAppSelector from "../../../hooks/useAppSelector";
import {
  loadLicenceProfileAsync,
  selectLicenceProfileResponse,
} from "../../../redux/slices/licenceProfile";
import useAppDispatch from "../../../hooks/useAppDispatch";
import Loading from "../../../leap-components/Loading";
import BackToCompliance from "../ComplianceTab/BackToCompliance";
import { useState } from "react";
import {
  GetLicenceProfileNotReadyComponent,
  IsLicenceProfileReady,
} from "../../../leap-components/LicenceProfile/LicenceProfileResponseComponentFactory";
import { ILicenceProfile } from "../../../api/ILicenceProfile";
import {
  loadInstructionAsync,
  selectInstruction,
} from "../../../redux/slices/instruction";
import InstructionHeader from "./InstructionHeader";
import InstructionDetails from "./InstructionDetails";
import Page500 from "../../../pages/auth/Page500";

const FindingAndRecommendation = () => {
  const [loading, setLoading] = useState(false);
  const [loadingInstructionById, setLoadingInstructionById] = useState("");
  const licenceProfileSelector = useAppSelector(selectLicenceProfileResponse);
  const instructionSelector = useAppSelector(selectInstruction);

  const dispatch = useAppDispatch();

  let { profileNo, instructionId } = useParams();
  if (!profileNo || !instructionId) {
    return <Page404 />;
  }

  if (!loading) {
    setLoading(true);
    dispatch(loadLicenceProfileAsync(profileNo));
  }

  if (!IsLicenceProfileReady(licenceProfileSelector.licenceProfileResponse)) {
    return GetLicenceProfileNotReadyComponent(
      licenceProfileSelector.licenceProfileResponse
    );
  }

  const licenceProfile = licenceProfileSelector.licenceProfileResponse
    ?.licenceProfile as ILicenceProfile;

  if (loadingInstructionById !== instructionId) {
    setLoadingInstructionById(instructionId);
    dispatch(loadInstructionAsync(instructionId));
    return <Loading />;
  }

  const instruction = instructionSelector.instruction;

  if (!instruction) {
    return <Loading />;
  }

  if (!instruction.response.ok) {
    if (instruction.response.status === 404) {
      return <Page404 />;
    } else {
      return <Page500 />;
    }
  }

  const contentElement = (
    <div>
      <Row>
        <Col className="col-12 col-md-12">
          <BackToCompliance profileNo={profileNo} />
        </Col>
      </Row>
      <Row>
        <Col className="col-12 col-sm-12 col-md-12">
          <InstructionHeader instruction={instruction} />
        </Col>
      </Row>
      <Row>
        <Col className="col-12 col-sm-12 col-md-12">
          <InstructionDetails instruction={instruction} />
        </Col>
      </Row>
      <Row>
        <Col className="col-12 col-md-12">
          <BackToCompliance profileNo={profileNo} />
        </Col>
      </Row>
      <Row>
        <Col className="col-12 col-sm-12 col-md-12">
          <RelatedComplianceRecords instruction={instruction} />
        </Col>
      </Row>
    </div>
  );

  return (
    <div>
      <BreadCrumbs licenceProfile={licenceProfile} instruction={instruction} />
      <div className="ps-0">
        <LicenceProfileHeader licenceProfile={licenceProfile} />
        <LicenceProfileSubTabs
          activeKey="compliance-records"
          content={contentElement}
          licenceProfile={licenceProfile}
        />
      </div>
    </div>
  );
};

export default FindingAndRecommendation;
